import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ingestion-multi-line',
  templateUrl: './ingestion-multi-line.component.html',
  styleUrls: ['./ingestion-multi-line.component.scss']
})
export class IngestionMultiLineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
